<template>
    <div class="line"
         v-if="!!checked">
        <div v-if="!onlyanswer">
            <div class="ask_title"
                 v-if="pageAsk.subject.content||pageAsk.subject.image">
                <span v-if="ask_length>1"
                      class="num">({{pageAsk.number}})</span>
                <!-- <span class="num" v-else>{{number}}、</span> -->
                <span v-if="pageAsk.subject.content.length"
                      class="title_p"
                      v-html="pageAsk.subject.content"></span>
                <img v-if="pageAsk.subject.image.length"
                     :src="pageAsk.subject.image" />
            </div>
        </div>
        <!-- 小题内容开始 -->
        <div class="line-wrap clearfix"
             :id="'canvasWrap'+pageAsk.id+pageTag">
            <canvas :id="'canvas'+pageAsk.id+pageTag"></canvas>
            <div class="line-left">
                <template v-for="option in pageAsk.options">
                    <div class="line-option answer-line-option"
                         v-if='option.link_id < 0'
                         :id="'optionLeft'+pageAsk.id+option.index+pageTag"
                         @click="chooseLeft(pageAsk.id,option.index)">
                        <span v-html="option.content"
                              v-if=" option.content "></span>
                        <img v-if="option.image"
                             :src="option.image"
                             alt="">
                    </div>
                </template>
            </div>
            <div class="line-right">
                <template v-for="option in pageAsk.options">
                    <div class="line-option answer-line-option"
                         v-if='option.link_id >= 0'
                         :id="'optionRight'+option.id+pageTag"
                         @click="chooseRight(pageAsk.id,option.id)">
                        <span v-html="option.content"
                              v-if=" option.content "></span>
                        <img v-if="option.image"
                             :src="option.image"
                             alt="">
                    </div>
                </template>
            </div>
        </div>
    </div>
    <div class="line"
         v-else>
        <div class="ask_title"
             v-if="pageAsk.subject.content||pageAsk.subject.image">
            <span class="num"
                  v-if="askLength>1">{{pageAsk.number}}、</span>
            <span v-if="pageAsk.subject.content"
                  v-html='pageAsk.subject.content'></span>
            <img :src="pageAsk.subject.image"
                 v-if="pageAsk.subject.image">
        </div>
        <!-- 小题内容开始 -->
        <div class="line-wrap clearfix"
             :id="'canvasWrap'+pageAsk.id+pageTag">
            <canvas :id="'canvas'+pageAsk.id+pageTag"></canvas>
            <div class="line-left">
                <template v-for="option in pageAsk.options">
                    <div :class="['line-option',{'inspect_myColor':myColor}]"
                         v-if='option.link_id < 0'
                         :id="'optionLeft'+pageAsk.id+option.index+pageTag"
                         @click="chooseLeft(pageAsk.id,option.index)">
                        <span v-html="option.content"
                              v-if=" option.content "></span>
                        <img v-if="option.image"
                             :src="option.image"
                             alt="">
                    </div>
                </template>
            </div>
            <div class="line-right">
                <template v-for="option in pageAsk.options">
                    <div :class="['line-option',{'inspect_myColor':myColor}]"
                         v-if='option.link_id >= 0'
                         :id="'optionRight'+option.id+pageTag"
                         @click="chooseRight(pageAsk.id,option.id)">
                        <span v-html="option.content"
                              v-if=" option.content "></span>
                        <img v-if="option.image"
                             :src="option.image"
                             alt="">
                    </div>
                </template>
            </div>
        </div>
    </div>
</template>
<script type="text/ecmascript-6">
export default {
    data () {
        return {
            onlyShowAnswer: false
        }
    },
    // 父组件通过ask字段 传给子组件当前题目的数据
    // sheet是用户答案
    // onlyshow 是否可操作
    // tag 每个连线实体的标记，为结果展示同ID试题做的标记
    computed: {
        pageAsk () { return this.ask },
        pageTag () { return this.tag ? this.tag : '' },
        lineColor () {
            if (this.myColor) {
                return '#5d89ef';
            } else {
                return (this.result == undefined || this.result == 0 ? '#cccccc' : 'hsl(120,50%,50%)');
            }

        },
        ask_length () {
            return this.askLength ? this.askLength : 2
        }
    },
    props: ['ask', 'sheet', 'onlyshow', 'tag', 'result', 'askLength', 'checked', 'number', 'onlyanswer', 'myColor', 'wrongType'],
    watch: {
        // 检测到ask变化，那就重绘整个页面
        ask () {
            this.initData()
            this.$nextTick(function () {
                this.initCanvas()
            })
        }
    },
    methods: {
        ruleSelector (selector) {
            function uni (selector) {
                return selector.replace(/::/g, ':') // for Firefox
            }
            return Array.prototype.filter.call(Array.prototype.concat.apply([], Array.prototype.map.call(document.styleSheets, function (x) {
                return Array.prototype.slice.call(x.cssRules);
            })), function (x) {
                return uni(x.selectorText) === uni(selector);
            });
        },
        leftEqRight () {
            // 判断左右个数是否一样
            let left = 0, right = 0;
            this.pageAsk.options.forEach(option => {
                if (option.link_id < 0) {
                    option.index = right;
                    right++;
                } else {
                    left++;
                }
            })
            return left == right;
        },
        chooseLeft (askId, index) {
            if (this.onlyShowAnswer) return false;
            // 获取选项的当前dom
            let target = document.getElementById('optionLeft' + askId + index + this.pageTag);
            if (!target) return false;

            let canvasObject = this.pageAsk.canvas;
            canvasObject.left = { target, index }
            // this.question.asks.splice(askindex,1,this.pageAsk.canvas)
            if (canvasObject.right && canvasObject.left) {
                this.makeObject(askId);
            }
        },
        chooseRight (askId, id) {
            if (this.onlyShowAnswer) return false;
            // 获取选项的当前dom
            let target = document.getElementById('optionRight' + id + this.pageTag);
            if (!target) return false;
            let canvasObject = this.pageAsk.canvas;
            canvasObject.right = { target, id };
            // this.question.asks.splice(askindex,1,this.pageAsk.canvas)
            if (canvasObject.left && canvasObject.left) {
                this.makeObject(askId);
            }
        },
        makeObject (askId) {
            let canvasObject = this.pageAsk.canvas;
            let _o = {};//左侧和右侧dom节点的x,y坐标
            // let to = canvasObject.right.index;//右侧的索引值
            let to = canvasObject.left.index;
            if (this.pageAsk.equal) {
                // 如果左边和右边的相等，那必须是一一对应的
                // 所以需将已经选中右侧的lineId删除
                for (let k in canvasObject.lineId) {
                    if (canvasObject.lineId[k].to == to) {
                        delete canvasObject.lineId[k];
                        break;
                    }
                }
            }
            // _o[canvasObject.left.id] = {...this.getLeftPos(canvasObject.left.target), ...this.getRightPos(canvasObject.right.target), ...{to}};
            _o[canvasObject.right.id] = { ...this.getRightPos(canvasObject.right.target), ...this.getLeftPos(canvasObject.left.target), ...{ to } };
            canvasObject.lineId = { ...canvasObject.lineId, ..._o };
            canvasObject.left = null;
            canvasObject.right = null;
            this.drawCanvas(askId);
        },
        drawCanvas (askId) {
            let canvasObject = this.pageAsk.canvas.lineId;
            let myCanvas = document.getElementById('canvas' + askId + this.pageTag)
            let context = myCanvas.getContext("2d");
            myCanvas.width = myCanvas.width
            context.strokeStyle = this.lineColor;//线颜色
            context.lineWidth = 2;//设置线宽
            let resultArray = [];
            for (let key in canvasObject) {
                let obj = canvasObject[key];
                context.moveTo(obj.x, obj.y);
                context.lineTo(obj.lx, obj.ly);
                resultArray.push(`${key}-${obj.to}`);
            }
            context.stroke();//画线框
            let _o = {
                askid: askId,
                result: resultArray.join('|'),
                askindex: this.pageAsk.number
            }
            if (!this.onlyshow) this.$emit('myResult', _o);
        },
        getLeftPos (target) {
            // 当前元素对应的绿点的坐标
            return {
                lx: target.offsetLeft + target.clientWidth,
                ly: target.offsetTop + target.clientHeight / 2
            }
        },
        getRightPos (target) {
            // 当前元素对应的绿点的坐标
            return {
                x: target.offsetLeft + target.parentNode.clientWidth,
                y: target.offsetTop + target.clientHeight / 2
            }
        },
        initData () {
            // 给每个小问添加原始数据
            this.pageAsk.canvas = {
                left: null,
                right: null,
                lineId: {}
            }
            this.pageAsk.equal = this.leftEqRight()
        },
        initCanvas () {
            // 初始化canvas，将canvas设置为和父元素一样宽高
            let canvas = document.getElementById('canvas' + this.pageAsk.id + this.pageTag);
            let wrapDiv = document.getElementById('canvasWrap' + this.pageAsk.id + this.pageTag)
            canvas.setAttribute('height', wrapDiv.clientHeight)
            canvas.setAttribute('width', wrapDiv.clientWidth)
            this.pageAsk.height = wrapDiv.clientHeight
            this.pageAsk.width = wrapDiv.clientWidth


            // 初始化sheet（答案）表，将用户答案渲染上去
            if (this.sheet) {
                let answer = ''
                // //console.log(this.sheet)
                // if(typeof this.sheet === 'object'){
                //     answer = this.sheet.answer.split('|');
                // }else{
                answer = this.sheet
                // }
                let askId = this.pageAsk.id;
                answer.forEach((option) => {
                    let _option = option.split('-');
                    this.chooseLeft(askId, _option[1]);
                    this.chooseRight(askId, _option[0]);
                })
            }
            // 如果是展示页面 在展示完后，加锁让所有不能点击
            this.onlyShowAnswer = this.onlyshow;
        }
    },
    mounted () {
        this.$nextTick(() => {
            if (!this.wrongType) {
                this.initCanvas();
            }
        })
    },
    created () {
        this.initData()
    }
}
</script>
<style rel="stylesheet/scss" lang="scss" scoped>
@import "SRC/assets/scss/common/_mixin";
.line {
    padding-top: 10px / $ppr;
    color: #555;
}
.ask_title {
    padding: 25px / $ppr;
    line-height: 46px / $ppr;
    font-size: 30px / $ppr;
    color: #333;
    border-bottom: 1px / $ppr solid #dcdcdc;
    margin-bottom: 30px / $ppr;
}
.line-wrap {
    position: relative;
    z-index: 1;
    border-bottom: 1px / $ppr solid #dcdcdc;
    canvas {
        position: absolute;
        left: 0;
        top: 0;
        z-index: 1;
    }
    .line-left,
    .line-right {
        width: 50%;
        position: relative;
        z-index: 2;
        img {
            max-width: 168px / $ppr;
            max-height: 128px / $ppr;
            display: block;
            margin: 0 auto;
        }
    }

    .line-option {
        width: 200px / $ppr;
        height: 160px / $ppr;
        background-color: #fff;
        text-align: center;
        word-wrap: break-word;
        word-break: break-all;
        position: relative;
        z-index: 1;
        border-radius: 16px / $ppr;
        display: inline-block;
        vertical-align: top;
        margin-bottom: 24px / $ppr;
        font-size: 30px / $ppr;
        line-height: 1.3rem;
        border: 1.2px / $ppr solid #000;
        span {
            width: 200px / $ppr;
            height: 160px / $ppr;
            overflow-y: scroll;
        }
        &:after {
            content: "";
            height: 24px / $ppr;
            width: 24px / $ppr;
            border-radius: 50%;
            border: 1px / $ppr solid #000;
            // background-color: #66cc22;
            background-color: #cccccc;
            position: absolute;
            top: 50%;
            margin-top: -12px / $ppr;
        }
    }
    .inspect_myColor {
        &:after {
            border: 1px / $ppr solid #5d89ef;
            background-color: #5d89ef;
        }
    }
    .answer-line-option {
        &:after {
            border: none;
            background-color: #ccc;
        }
    }
    .line-left {
        float: left;
        text-align: left;
        .line-option {
            margin-left: 60px / $ppr;
            &:after {
                right: -12px / $ppr;
            }
        }
    }
    .line-right {
        float: right;
        text-align: right;
        .line-option {
            margin-right: 60px / $ppr;
            &:after {
                left: -12px / $ppr;
            }
        }
    }
}
</style>
